export default __webpack_public_path__ + "static/media/Mysore_Tipu's gumbaj_2.c7d0371d.jpg";